// Apartments
export const PROPERTY_TYPES = ["luxury", "leaseup", "affordable housing", "55+", "student housing"];
export const PROPERTY_STRUCTURES = ["highrise", "midrise", "garden style", "boutique", "historic"];
export const PROPERTY_CLASSES = ["A", "B", "C"];
